import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { HeaderComponent } from 'src/app/layout/components/header/header.component';
@Injectable({
  providedIn: 'root',
})
export class StepSharedService {
  private stepSubject = new BehaviorSubject<number>(0);
  private dataSetting = new BehaviorSubject<boolean>(false);

  changeStep(step: number): void {
    this.stepSubject.next(step);
  }

  getStep(): BehaviorSubject<number> {
    return this.stepSubject;
  }

  sendData(data: any) {
    this.dataSetting.next(data);
  }
  getData(): BehaviorSubject<boolean> {
    return this.dataSetting;
  }
}
